export const IS_LOADING = "IS_LOADING";
export const IS_LOADINGINTRO = "IS_LOADINGINTRO";
export const IS_LOADINGFRIST = "IS_LOADINGFRIST";


